import React, { useCallback, useState } from "react";
// import AdminsList from "./Trainers";
// import UsersList from "./Patients";
import { useDispatch, useSelector } from "react-redux";
import {
  DefaultButton,
  Image,
  Spinner,
  SpinnerSize,
} from "office-ui-fabric-react";
import SignOutButton from "gatsby-plugin-hfn-profile/auth/SignOutButton";
import { validateEmail } from "@heartfulnessinstitute/react-hfn-forms/dist/validations";
import { DynamicField } from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";
import { Div } from "../components/Bootstrap";
import {
  trainersCareAppUrl,
  adminsCareAppUrl,
  patientsCareAppUrl,
  patientsMineCareAppUrl,
} from "./urls";
import { selectorSettings } from "../common1/firebase-selectors/settings";
import Banner from "../assets/hfncare-banner.png";
import Logo from "../assets/hfn-logo-black.svg";
import { WarningLightButton } from "../components/Button";
import { setBehaveAs } from "../state/appActions";
import "./home.css";

function Home() {
  const { amIAdmin, amITrainer } = useSelector(selectorSettings);

  const [b, setB] = useState("");

  const dispatch = useDispatch();

  const setBehaveAsUser = useCallback(() => {
    if (b) {
      dispatch(setBehaveAs(b));
    }
  }, [b, dispatch]);

  const loading = amIAdmin === undefined || amITrainer === undefined;

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner size={SpinnerSize.large} />
      </div>
    );
  }

  return (
    <div>
      <Div className="container-md mt-3">
        {!amITrainer && !amIAdmin ? (
          <div className="no-access-container">
            <Image src={Logo} width="250px" />
            <h3 className="no-access-message">
              You do not have access to this application. Please contact your
              reporting functionary.
            </h3>
            <SignOutButton btnText="Login with another Account" />
            <div className="no-access-note">
              <h4>
                Note: On clicking &quot;Login with another account&quot; you
                will be logged out from all Heartfulness applications in this
                browser.
              </h4>
            </div>
          </div>
        ) : (
          <>
            <Image src={Banner} width="100vw" />

            <Div className="card-deck">
              {amITrainer && (
                <Div className="card">
                  <Div className="card-header">
                    <b>Trainers Section</b>
                  </Div>
                  <Div className="card-body">
                    <DefaultButton
                      href={patientsMineCareAppUrl()}
                      text="My Patients"
                      iconProps={{ iconName: "People" }}
                    />
                  </Div>
                </Div>
              )}
              {amIAdmin && (
                <Div className="card">
                  <Div className="card-header">
                    <b>Admin Section</b>
                  </Div>
                  <Div className="card-body">
                    <DefaultButton
                      href={patientsCareAppUrl()}
                      text="All Patients"
                      iconProps={{ iconName: "Group" }}
                    />

                    <DefaultButton
                      href={trainersCareAppUrl()}
                      text="Care Trainers"
                      iconProps={{ iconName: "WebAppBuilderFragment" }}
                    />
                    <DefaultButton
                      href={adminsCareAppUrl()}
                      text="Admins"
                      iconProps={{ iconName: "Sunny" }}
                    />

                    <Div>
                      <DynamicField
                        name="loginemulate"
                        label="Emulate Login Email"
                        value={b}
                        onChange={setB}
                        props={{
                          description:
                            "see how this site appears to a particular user",
                        }}
                      />

                      {!!b && validateEmail(b) && (
                        <WarningLightButton
                          text={`Click to emulate user ${b}`}
                          onClick={setBehaveAsUser}
                        />
                      )}
                    </Div>
                  </Div>
                </Div>
              )}
            </Div>
          </>
        )}
      </Div>
    </div>
  );
}

export default React.memo(Home);
